import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import ExportButton from 'components/Layout/ExportButton';
import { icons, limit } from 'utils/constants';
import {
  deleteEventParticipants,
  getEventParticipantRequest,
  getEventParticipants,
  participantSendRequest,
  showSuccess,
  updateUserDetails,
} from 'store/slices';
import {
  getDataFromLocalStorage,
  objectToFormData,
  titleCaseString,
  paymentColor,
} from 'utils/helpers';
import { useParams } from 'react-router-dom';
import Button from 'components/form/Button/Button';
import ParticipantsForm from './ParticipantsForm';
import DeletePopup from 'components/Layout/DeletePopup/DeletePopup';
// import AbstractSubmission from "./AbstractSubmission";
import NewAbstractSubmissionFormPopup from 'components/V2ForNewAbstractFlow/NewAbstractSubmissionFormPopup';
import CheckBox from 'components/form/CheckBox';
import AddMember from 'pages/Common/ProfileManagement/AddMember';
import { values } from 'lodash';
import SeachInput from 'components/form/SeachInput';
import Loader from 'components/Layout/Loader';
import PaymentProofUploadPopup from './PaymentProofUploadPopup';
import ParticipantsPopup from './ParticipantsPopup';
import usePermission from 'hooks/usePermission';

const Participants = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { eventId } = params;
  const { membershipList, userDetails } = useSelector((state) => ({
    membershipList: state.global.membershipList,
    userDetails: state.student.userDetails,
  }));
  const [abstractData, setAbstractData] = useState(null);
  const [userID, setUserID] = useState('');
  const [oldData, setOldData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdd, setIsAdd] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [timer, setTimer] = useState('');
  const [searchPayload, setSearchPayload] = useState({
    name: '',
    email_id: '',
    member_id: '',
    phone_number: '',
  });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
    event_id: eventId,
  });
  const user_type = getDataFromLocalStorage('user_type');
  const [selectedIds, setSelectedIds] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isAddMember, setAddMember] = useState(false);
  const [requestId, setRequestId] = useState('');
  const [isSendingRequest, setIsSendingRequest] = useState(false);
  const [sendingRequestId, setSendingRequestId] = useState(null);
  const [isView, setIsView] = useState(false);
  const [openPaymentPopup, setOpenPaymentPopup] = useState(false);
  const [participantsPopup, setParticipantsPopup] = useState({
    open: false,
    mode: "", // "view" | "edit"
  });
  const [selectedOption, setSelectedOption] = useState(false)

  const handleUpdateUserDetails = async (user_id) => {
    const payload = {
      request_id: requestId,
      user_id: user_id,
    };
    const response = await dispatch(updateUserDetails(payload));
    if (response.status === 200) {
      setRequestId('');
      getParticipants({ ...filterData, ...searchPayload });
    }
  };

  //getParticipants Request
  const getParticipants = async (obj) => {
    let forData = objectToFormData(obj);
    let response;

    if (user_type === '6') {
      response = await dispatch(getEventParticipantRequest(forData));
    } else {
      response = await dispatch(getEventParticipants(forData));
    }

    setTableList(response?.data?.events_registered_members || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

  //serchdata
  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getParticipants(newData);
  };

  //Pagination
  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getParticipants(newData);
  };

  useEffect(() => {
    getParticipants({ ...filterData, ...searchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const path = window.location.pathname;
  const segments = path.split('/');
  const targetValue = segments[2] || '';

  const permissionMapping = {
    'event-management': 'Event Management',
    'chapters-groups': 'Chapters & Group Management',
  };
  const permissionName = permissionMapping[targetValue] || '';
  const { viewAccess, updateAccess, deleteAccess, createAccess } = usePermission(permissionName);

  // const isShowEditBtn = updateAccess === "1";
  // const isShowDeleteBtn = deleteAccess === "1";
  // const isShowCreateBtn = createAccess === "1";

  const handleSelectAllChange = () => {
    setIsCheckAll((prev) => !prev);
    setSelectedIds(
      isCheckAll
        ? []
        : tableList
          .filter((item) => item.display_checkbox)
          .map(({ request_id }) => request_id)
    );
  };

  const handleCheckboxChange = (request_id, isChecked) => {
    setSelectedIds((prev) => {
      const updatedSelectedIds = isChecked
        ? [...prev, request_id]
        : prev.filter((selectedId) => selectedId !== request_id);
      const totalCheckboxCount = tableList.filter(
        (item) => item.display_checkbox
      ).length;
      setIsCheckAll(updatedSelectedIds.length === totalCheckboxCount);
      return updatedSelectedIds;
    });
  };

  const handleSearch = (e) => {
    let value = e?.target?.value;
    setSearchText(value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      const updatedSearchPayload = { ...searchPayload, global_filter: value };
      setSearchPayload(updatedSearchPayload);
      const updatedFilterData = {
        ...filterData,
        offset: 0,
        ...updatedSearchPayload,
      };
      setIsLoading(true);
      setFilterData(updatedFilterData);
      getParticipants(updatedFilterData);
    }, 800);
    setTimer(time);
  };

  const handleParticipantSendRequest = async (data) => {
    if (Array.isArray(data)) {
      setIsSendingRequest(true);
    } else {
      setSendingRequestId(data);
    }

    const payload = {
      request_ids: data,
    };
    const response = await dispatch(
      participantSendRequest(objectToFormData(payload))
    );
    if (response.status === 200) {
      setIsSendingRequest(false);
      setSendingRequestId(null);
      setSelectedIds([]);
      getParticipants({ ...filterData, ...searchPayload });
      dispatch(showSuccess(response?.message));
    }
  };

  const header = [
    ...(user_type === '6' ? [{ isSearch: false }, {
      isCollapse: true,
      title: '',
      isSearch: false
    }] : []),

    {
      isSearch: user_type !== '6' ? true : false,
      searchInputName: 'name',
      title: 'Name',
    }, {
      isSearch: false,
      searchInputName: 'author_type',
      title: 'Author Type',
    },


    {
      isSearch: user_type !== '6' ? true : false,
      searchInputName: 'join_as',
      title: 'Join As',
    },
    {
      isSearch: user_type !== '6' ? true : false,
      isSearchDropdown: user_type !== '6' ? true : false,
      dropdownOptions: { options: membershipList, key: 'id', value: 'name' },
      searchInputName: 'member_id',
      title: 'Membership Type',
    },
    {
      isSearch: user_type !== '6' ? true : false,
      searchInputName: 'email_id',
      title: 'Email ID',
    },
    {
      isSearch: user_type !== '6' ? true : false,
      searchInputName: 'phone_number',
      title: 'Mobile',
    },
    ...(user_type === '6'
      ? [
        {
          isSearch: false,
          searchInputName: 'status',
          title: 'Status',
        },
      ]
      : []),
    {
      isSearch: false,
      // searchLable: 'Edit/Delete',
      title: 'Action',
    },
  ];

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleRow = (rowId) => {
    if (rowId === undefined || rowId === null) {
      return;
    }
    setExpandedRows(prev => {
      const cleanPrev = prev.filter(id => id !== undefined);
      return cleanPrev.includes(rowId)
        ? cleanPrev.filter(id => id !== rowId)
        : [...cleanPrev, rowId];
    });
  };

  const rowData = [];
  tableList?.forEach((elem) => {
    if (!elem.request_id) return;
    const isExpanded = expandedRows.includes(elem.request_id);
    const hasCoAuthors = elem.co_authors && elem.co_authors.length > 0;

    let obj = [
      {
        value: elem.display_checkbox ? (
          <div className="d-flex justify-content-center align-items-center">
            <input
              type="checkbox"
              className={`custom-checkbox ${selectedIds.includes(elem?.request_id)
                ? 'activeChecked'
                : 'activeUnchecked'
                }`}
              onChange={(e) =>
                handleCheckboxChange(elem?.request_id, e.target.checked)
              }
              checked={selectedIds.includes(elem?.request_id)}
            />
          </div>
        ) : null,
      },

      {
        value: (
          <div className="d-flex justify-content-center align-items-center">
            {hasCoAuthors ? (
              <span
                className={`expand-icon pointer ${isExpanded ? 'expanded' : ''}`}
                onClick={() => toggleRow(elem.request_id)}
                style={{
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease',
                  transform: isExpanded ? 'rotate(270deg)' : 'rotate(90deg)',

                }}
              >
                <i className="bi bi-chevron-left" />
              </span>
            ) : (
              <span style={{ width: '16px', height: '16px' }}></span>
            )}
          </div>
        )
      },

      {
        value: elem?.name ? elem?.name : '-',
      },
      {
        value: 'Author',
      },
      {
        value: titleCaseString(elem?.join_as),
      },
      {
        value: elem.member_type ? elem.member_type : '-',
      },
      {
        value: elem.email_id,
      },
      {
        value: elem.phone_number ? elem.phone_number : '-',
      },

      {
        value: (
          <div className={paymentColor(elem?.status)}>{elem?.status}</div>
        ),
      },

      {
        value: (


          <>
            <div className="">
              <span className="action-icon-buttons mt-2 mb-2">
                {updateAccess === '1' && !elem?.display_add_member_btn &&
                  <Button
                    btnStyle="light-outline"
                    icon={<img src={icons.edit} alt="edit" />}
                    className="me-2"
                    onClick={() => {
                      // setAbstractData(elem);
                      // setRequestId(elem?.request_id);
                      setParticipantsPopup({
                        open: true,
                        mode: "edit",
                        data: elem
                      })
                    }}
                    isSquare
                  />
                }

                {/* elem.display_edit_btn && */}
                {viewAccess === '1' && !elem?.display_add_member_btn &&
                  <Button
                    btnStyle="light-outline"
                    icon={<i className="bi bi-eye" />}
                    className="me-2"
                    isSquare
                    onClick={() => {
                      setParticipantsPopup({
                        open: true,
                        mode: "view",
                        data: elem
                      })
                      // setAbstractData(elem);
                      // setRequestId(elem?.request_id);
                      // setIsView(true);
                    }}
                  />
                }

                {/* !elem?.display_submit_abstract &&
                      !elem?.display_add_member_btn &&  */}
              </span>

              <div className="d-flex align-items-center justify-content-center">
                {elem?.display_add_member_btn && createAccess === '1' && (
                  <span>
                    <Button
                      text="Add Member"
                      btnStyle="primary-outline"
                      icon={<i className="bi bi-plus fs-5"></i>}
                      onClick={() => {
                        setAddMember(!isAddMember);
                        setRequestId(elem?.request_id);
                      }}
                      className="h-35 text-14-400 text-nowrap"
                    />
                  </span>
                )}

                {elem?.display_submit_abstract && (
                  <span
                  // className={
                  //   elem.user_id && elem.join_as === 'presenter' ? '' : 'd-none'
                  // }
                  >
                    {createAccess === '1' && (
                      <Button
                        btnStyle="primary-dark"
                        text="Submit Abstarct"
                        className="me-2 h-35 text-14-400 text-nowrap"
                        onClick={() => {
                          setAbstractData(elem);
                          setRequestId(elem?.request_id);
                        }}
                      />
                    )}
                  </span>
                )}

                {elem?.display_payment_proof_btn &&
                  createAccess === '1' && (
                    <span>
                      <Button
                        btnStyle="primary-outline1"
                        text="Payment Proof"
                        className="me-2 h-35 text-14-400 text-nowrap"
                        onClick={() => {
                          setOpenPaymentPopup(true);
                          setRequestId(elem?.request_id);
                        }}
                      />
                    </span>
                  )}

                {elem?.display_checkbox && (
                  <span>
                    {createAccess === '1' && (
                      <Button
                        btnStyle="primary-dark"
                        text={
                          sendingRequestId === elem?.request_id
                            ? 'Sending...'
                            : 'Send Request'
                        }
                        className="me-2 h-35 text-14-400 text-nowrap"
                        onClick={() => {
                          handleParticipantSendRequest(elem?.request_id);
                        }}
                        disabled={
                          sendingRequestId === elem?.request_id ||
                          isSendingRequest
                        }
                      />
                    )}
                  </span>
                )}
              </div>
            </div>
          </>


        ),
      },
    ];

    rowData.push({
      data: obj,
      id: elem.request_id,
      isExpanded: isExpanded,
      hasChildren: hasCoAuthors,
      rawData: elem
    });

    if (isExpanded && hasCoAuthors) {
      elem?.co_authors?.forEach((coAuthor, coIndex) => {
        const coAuthorRow = [
          { value: <div style={{ width: '16px' }}></div> },

          { value: <div style={{ width: '16px' }}></div> },

          {
            value: (
              <div style={{ paddingLeft: '20px' }}>
                {coAuthor.name || '-'}
              </div>
            )
          },

          { value: 'Co-Author' },
          { value: titleCaseString(elem?.join_as) },
          { value: elem.member_type ? elem.member_type : '-' },

          { value: coAuthor.email || '-' },

          {
            value: coAuthor.phone
              ? `${coAuthor.phone}`
              : '-'
          },

          { value: <div className={paymentColor(elem?.status)}>{elem?.status}</div> }
          ,

          { value: '' }
        ];

        rowData.push({
          data: coAuthorRow,
          id: `${elem.request_id}-coauthor-${coIndex}`,
          isChild: true,
          parentId: elem.request_id,
          rawData: coAuthor,
        });
      });
    }
  });

  const adminRowData = [];
  tableList.forEach((elem) => {
    let obj = [

      {
        value: elem?.name ? elem?.name : '-',
      },
      {
        value: 'Author',
      },
      {
        value: titleCaseString(elem?.join_as),
      },
      {
        value: elem.member_type ? elem.member_type : '-',
      },
      {
        value: elem.email_id,
      },
      {
        value: elem.phone_number ? elem.phone_number : '-',
      },

      {
        value: (
          <>

            <>
              <span
                className={
                  elem.user_id && elem.join_as === 'presenter' ? '' : 'd-none'
                }
              >
                {createAccess === '1' && (
                  <Button
                    btnStyle="primary-dark"
                    text="Submit Abstarct"
                    className="me-2 h-35 text-14-400 text-nowrap"
                    onClick={() => {
                      setAbstractData(elem);
                    }}
                  />
                )}
              </span>

              <span className="action-icon-buttons mt-2">
                {updateAccess === '1' && (
                  <Button
                    btnStyle="light-outline"
                    icon={<img src={icons.edit} alt="edit" />}
                    className="me-2"
                    onClick={() => {
                      setOldData(elem);
                      setIsAdd(true);
                    }}
                    isSquare
                  />
                )}

                {deleteAccess === '1' && (
                  <Button
                    btnStyle="light-outline"
                    icon={<img src={icons.deleteIcon} alt="delete" />}
                    onClick={() => {
                      setUserID(elem?.id);
                    }}
                    isSquare
                  />
                )}
              </span>
            </>


          </>
        ),
      },
    ];
    adminRowData.push({ data: obj });
  });

  return (
    <>
      {isAddMember && (
        <AddMember
          onHide={() => {
            setAddMember(false);
          }}
          handelSuccess={(user_id) => {
            setAddMember(false);
            handleUpdateUserDetails(user_id);
          }}
        />
      )}

      {isAdd && (
        <ParticipantsForm
          oldData={oldData}
          onHide={() => {
            setIsAdd(false);
            setOldData(null);
          }}
          getParticipants={() => {
            getParticipants({ ...filterData, ...searchPayload });
            setOldData(null);
          }}
        />
      )}

      {userID && (
        <DeletePopup
          onHide={() => {
            setUserID(null);
          }}
          handelSuccess={() => {
            setUserID(null);
            getParticipants({ ...filterData, ...searchPayload });
          }}
          handelDelete={async () => {
            let forData = objectToFormData({ id: userID });
            const response = await dispatch(deleteEventParticipants(forData));
            return response;
          }}
        />
      )}
      {/* New flow */}
      {abstractData && (
        <NewAbstractSubmissionFormPopup
          eventId={eventId}
          data={{
            ...abstractData,
            resource_participat_paper: '1',
            participat_request_id: requestId,
          }}
          onHide={() => {
            setAbstractData(null);
            setIsView(false);
          }}
          handelSuccess={() => {
            setRequestId('');
            getParticipants({ ...filterData, ...searchPayload });
          }}
          isView={isView}
        />
      )}


      {/* Old flow */}
      {/* {abstractData && (
        <AbstractSubmission
          eventId={eventId}
          data={abstractData}
          onHide={() => {
            setAbstractData(null);
          }}
        />
      )} */}

      {openPaymentPopup && (
        <PaymentProofUploadPopup
          onHide={() => setOpenPaymentPopup(false)}
          requestId={requestId}
          handelSuccess={() => {
            setRequestId(null);
            getParticipants({ ...filterData, ...searchPayload });
          }}
        />
      )}

      {isLoading ? (
        <Card className="cpt-80 cpb-80 cmt-20">
          <Loader size="md" />
        </Card>
      ) : (
        <Card className="cps-20 cpe-20 cpb-20 mt-3">
          {tableList.length === 0 ? (
            <div className="row" style={{ minHeight: '600px' }}>
              <div className="d-flex flex-column justify-content-center align-items-center w-100">
                <div className="text-center">
                  <img
                    src={icons.circleInfo}
                    alt="No Data"
                    className="h-60 w-60"
                  />
                  <div className="text-32-500-40 cmt-28 color-black-olive">
                    Add Participants Services Not Found
                  </div>
                </div>

                <div className="cmt-20">
                  <Button
                    text="+ Add Participants"
                    btnStyle="primary-outline"
                    className="h-35 text-14-500 text-nowrap cps-20 cpe-20"
                    onClick={() => {
                      setIsAdd(true);
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center cpt-28 cpb-28">
                {selectedIds.length === 0 ? (
                  <div className="table-title">
                    All Participants ({filterData?.total})
                  </div>
                ) : (
                  <>
                    <div className="d-flex gap-2 h-35">
                      <div className="d-flex align-items-center gap-2 p-2 text-14-400-18 br-6 bg-f4fc">
                        <CheckBox
                          type="ACTIVE"
                          isChecked={isCheckAll}
                          onClick={handleSelectAllChange}
                        />
                        <span>Select All Users</span>
                      </div>
                      <div className="d-flex align-items-center gap-2 p-2 text-14-400-18 br-6 bg-f4fc">
                        <Button
                          text={
                            isSendingRequest ? 'Sending...' : 'Send Request'
                          }
                          className="h-35 border-0"
                          onClick={() =>
                            handleParticipantSendRequest(selectedIds)
                          }
                          disabled={isSendingRequest}
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="d-flex gap-2">
                  <div style={{ width: '150px' }}>
                    <SeachInput
                      placeholder="Search"
                      value={searchText}
                      onChange={handleSearch}
                      className="small-text-input"
                      iconClassName="small-search-icon"
                    />
                  </div>

                  <ExportButton
                    exportAPI={
                      user_type === '6'
                        ? getEventParticipantRequest
                        : getEventParticipants
                    }
                    payload={objectToFormData({
                      event_id: eventId,
                      export_status: 1,
                      ...filterData,
                      ...searchPayload,
                      ...(searchText ? { global_filter: searchText } : {}),
                    })}
                  />
                  {createAccess === '1' && (
                    <Button
                      isSquare
                      text="+ Add Participants"
                      btnStyle="primary-outline"
                      className="h-35 text-14-500 text-nowrap"
                      onClick={() => {
                        setIsAdd(true);
                      }}
                    />
                  )}
                </div>
              </div>
              <Table
                isLoading={isLoading}
                header={header}
                rowData={user_type === "6" ? rowData : adminRowData}
                filterData={filterData}
                searchPayload={searchPayload}
                searchInputChange={handelChangeSearch}
                changeOffset={handelChangePagination}
                expandedRows={expandedRows}
                toggleRow={toggleRow}
              />
            </>
          )}
        </Card>
      )}


      {participantsPopup?.open && (
        <ParticipantsPopup
          participantsPopup={participantsPopup}
          onHide={() => {
            setParticipantsPopup({ open: false, mode: "" })
            setSelectedOption(null) // reset when popup closes
          }}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          getParticipants={getParticipants}
          filterData={filterData}
          searchPayload={searchPayload}
        />
      )}
    </>
  );
};
export default Participants;

// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import Card from 'components/Layout/Card';
// import Table from 'components/Layout/Table';
// import ExportButton from 'components/Layout/ExportButton';
// import { icons, limit } from 'utils/constants';
// import {
//   deleteEventParticipants,
//   getEventParticipantRequest,
//   getEventParticipants,
//   participantSendRequest,
//   showSuccess,
//   updateUserDetails,
// } from 'store/slices';
// import {
//   getDataFromLocalStorage,
//   objectToFormData,
//   titleCaseString,
//   paymentColor,
// } from 'utils/helpers';
// import { useParams } from 'react-router-dom';
// import Button from 'components/form/Button/Button';
// import ParticipantsForm from './ParticipantsForm';
// import DeletePopup from 'components/Layout/DeletePopup/DeletePopup';
// // import AbstractSubmission from "./AbstractSubmission";
// import NewAbstractSubmissionFormPopup from 'components/V2ForNewAbstractFlow/NewAbstractSubmissionFormPopup';
// import CheckBox from 'components/form/CheckBox';
// import AddMember from 'pages/Common/ProfileManagement/AddMember';
// import { values } from 'lodash';
// import SeachInput from 'components/form/SeachInput';
// import Loader from 'components/Layout/Loader';
// import PaymentProofUploadPopup from './PaymentProofUploadPopup';
// import ParticipantsPopup from './ParticipantsPopup';

// const Participants = () => {
//   const dispatch = useDispatch();
//   const params = useParams();
//   const { eventId } = params;
//   const { membershipList, userDetails } = useSelector((state) => ({
//     membershipList: state.global.membershipList,
//     userDetails: state.student.userDetails,
//   }));
//   const [abstractData, setAbstractData] = useState(null);
//   const [userID, setUserID] = useState('');
//   const [oldData, setOldData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isAdd, setIsAdd] = useState(false);
//   const [tableList, setTableList] = useState([]);
//   const [searchText, setSearchText] = useState('');
//   const [timer, setTimer] = useState('');
//   const [searchPayload, setSearchPayload] = useState({
//     name: '',
//     email_id: '',
//     member_id: '',
//     phone_number: '',
//   });
//   const [filterData, setFilterData] = useState({
//     total: 0,
//     offset: 0,
//     limit: limit,
//     event_id: eventId,
//   });
//   const user_type = getDataFromLocalStorage('user_type');
//   const [selectedIds, setSelectedIds] = useState([]);
//   const [isCheckAll, setIsCheckAll] = useState(false);
//   const [isAddMember, setAddMember] = useState(false);
//   const [requestId, setRequestId] = useState('');
//   const [isSendingRequest, setIsSendingRequest] = useState(false);
//   const [sendingRequestId, setSendingRequestId] = useState(null);
//   const [isView, setIsView] = useState(false);
//   const [openPaymentPopup, setOpenPaymentPopup] = useState(false);
//   const [participantsPopup, setParticipantsPopup] = useState({
//     open: false,
//     mode: "", // "view" | "edit"
//   });
//   const [selectedOption, setSelectedOption] = useState(false)

//   const handleUpdateUserDetails = async (user_id) => {
//     const payload = {
//       request_id: requestId,
//       user_id: user_id,
//     };
//     const response = await dispatch(updateUserDetails(payload));
//     if (response.status === 200) {
//       setRequestId('');
//       getParticipants({ ...filterData, ...searchPayload });
//     }
//   };

//   //getParticipants Request
//   const getParticipants = async (obj) => {
//     let forData = objectToFormData(obj);
//     let response;

//     if (user_type === '6') {
//       response = await dispatch(getEventParticipantRequest(forData));
//     } else {
//       response = await dispatch(getEventParticipants(forData));
//     }

//     setTableList(response?.data?.events_registered_members || []);
//     setFilterData({
//       ...obj,
//       total: response?.data?.result_count || 0,
//     });
//     setIsLoading(false);
//   };

//   //serchdata
//   const handelChangeSearch = (searchData) => {
//     setIsLoading(true);
//     let newData = filterData;
//     setSearchPayload(searchData);
//     newData = { ...newData, ...searchData, offset: 0 };
//     setFilterData(newData);
//     getParticipants(newData);
//   };

//   //Pagination
//   const handelChangePagination = (offset) => {
//     setIsLoading(true);
//     let newData = { ...filterData, ...searchPayload };
//     newData = { ...newData, offset: offset };
//     setFilterData(newData);
//     getParticipants(newData);
//   };

//   useEffect(() => {
//     getParticipants({ ...filterData, ...searchPayload });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const path = window.location.pathname;
//   const segments = path.split('/');
//   const targetValue = segments[2] || '';

//   const permissionMapping = {
//     'event-management': 'Event Management',
//     'chapters-groups': 'Chapters & Group Management',
//   };
//   const permissionName = permissionMapping[targetValue] || '';

//   const {
//     view: viewAccess,
//     update: updateAccess,
//     delete: deleteAccess,
//     create: createAccess,
//   } = userDetails?.role_data?.find(
//     (item) => item?.permission_name === permissionName
//   )?.sub_permission || {};

//   // const isShowEditBtn = updateAccess === "1";
//   // const isShowDeleteBtn = deleteAccess === "1";
//   // const isShowCreateBtn = createAccess === "1";

//   const handleSelectAllChange = () => {
//     setIsCheckAll((prev) => !prev);
//     setSelectedIds(
//       isCheckAll
//         ? []
//         : tableList
//           .filter((item) => item.display_checkbox)
//           .map(({ request_id }) => request_id)
//     );
//   };

//   const handleCheckboxChange = (request_id, isChecked) => {
//     setSelectedIds((prev) => {
//       const updatedSelectedIds = isChecked
//         ? [...prev, request_id]
//         : prev.filter((selectedId) => selectedId !== request_id);
//       const totalCheckboxCount = tableList.filter(
//         (item) => item.display_checkbox
//       ).length;
//       setIsCheckAll(updatedSelectedIds.length === totalCheckboxCount);
//       return updatedSelectedIds;
//     });
//   };

//   const handleSearch = (e) => {
//     let value = e?.target?.value;
//     setSearchText(value);
//     let time = timer;
//     clearTimeout(time);
//     time = setTimeout(() => {
//       const updatedSearchPayload = { ...searchPayload, global_filter: value };
//       setSearchPayload(updatedSearchPayload);
//       const updatedFilterData = {
//         ...filterData,
//         offset: 0,
//         ...updatedSearchPayload,
//       };
//       setIsLoading(true);
//       setFilterData(updatedFilterData);
//       getParticipants(updatedFilterData);
//     }, 800);
//     setTimer(time);
//   };

//   const handleParticipantSendRequest = async (data) => {
//     if (Array.isArray(data)) {
//       setIsSendingRequest(true);
//     } else {
//       setSendingRequestId(data);
//     }

//     const payload = {
//       request_ids: data,
//     };
//     const response = await dispatch(
//       participantSendRequest(objectToFormData(payload))
//     );
//     if (response.status === 200) {
//       setIsSendingRequest(false);
//       setSendingRequestId(null);
//       setSelectedIds([]);
//       getParticipants({ ...filterData, ...searchPayload });
//       dispatch(showSuccess(response?.message));
//     }
//   };

//   const header = [
//     ...(user_type === '6' ? [{ isSearch: false }] : []),
//     {
//       isSearch: user_type !== '6' ? true : false,
//       searchInputName: 'name',
//       title: 'Name',
//     },
//     {
//       isSearch: user_type !== '6' ? true : false,
//       searchInputName: 'join_as',
//       title: 'Join As',
//     },
//     {
//       isSearch: user_type !== '6' ? true : false,
//       isSearchDropdown: user_type !== '6' ? true : false,
//       dropdownOptions: { options: membershipList, key: 'id', value: 'name' },
//       searchInputName: 'member_id',
//       title: 'Membership Type',
//     },
//     {
//       isSearch: user_type !== '6' ? true : false,
//       searchInputName: 'email_id',
//       title: 'Email ID',
//     },
//     {
//       isSearch: user_type !== '6' ? true : false,
//       searchInputName: 'phone_number',
//       title: 'Mobile',
//     },
//     ...(user_type === '6'
//       ? [
//         {
//           isSearch: false,
//           searchInputName: 'status',
//           title: 'Status',
//         },
//       ]
//       : []),
//     {
//       isSearch: false,
//       // searchLable: 'Edit/Delete',
//       title: 'Action',
//     },
//   ];

//   const rowData = [];
//   tableList.forEach((elem) => {
//     let obj = [
//       ...(user_type === '6'
//         ? [
//           {
//             value: elem.display_checkbox ? (
//               <div className="d-flex justify-content-center align-items-center">
//                 <input
//                   type="checkbox"
//                   className={`custom-checkbox ${selectedIds.includes(elem?.request_id)
//                     ? 'activeChecked'
//                     : 'activeUnchecked'
//                     }`}
//                   onChange={(e) =>
//                     handleCheckboxChange(elem?.request_id, e.target.checked)
//                   }
//                   checked={selectedIds.includes(elem?.request_id)}
//                 />
//               </div>
//             ) : null,
//           },
//         ]
//         : []),

//       {
//         value: elem?.name ? elem?.name : '-',
//       },
//       {
//         value: titleCaseString(elem?.join_as),
//       },
//       {
//         value: elem.member_type ? elem.member_type : '-',
//       },
//       {
//         value: elem.email_id,
//       },
//       {
//         value: elem.phone_number ? elem.phone_number : '-',
//       },
//       ...(user_type === '6'
//         ? [
//           {
//             value: (
//               <div className={paymentColor(elem?.status)}>{elem?.status}</div>
//             ),
//           },
//         ]
//         : []),
//       {
//         value: (
//           <>
//             {user_type !== '6' ? (
//               <>
//                 <span
//                   className={
//                     elem.user_id && elem.join_as === 'presenter' ? '' : 'd-none'
//                   }
//                 >
//                   {createAccess === '1' && (
//                     <Button
//                       btnStyle="primary-dark"
//                       text="Submit Abstarct"
//                       className="me-2 h-35 text-14-400 text-nowrap"
//                       onClick={() => {
//                         setAbstractData(elem);
//                       }}
//                     />
//                   )}
//                 </span>

//                 <span className="action-icon-buttons mt-2">
//                   {updateAccess === '1' && (
//                     <Button
//                       btnStyle="light-outline"
//                       icon={<img src={icons.edit} alt="edit" />}
//                       className="me-2"
//                       onClick={() => {
//                         setOldData(elem);
//                         setIsAdd(true);
//                       }}
//                       isSquare
//                     />
//                   )}

//                   {deleteAccess === '1' && (
//                     <Button
//                       btnStyle="light-outline"
//                       icon={<img src={icons.deleteIcon} alt="delete" />}
//                       onClick={() => {
//                         setUserID(elem?.id);
//                       }}
//                       isSquare
//                     />
//                   )}
//                 </span>
//               </>
//             ) : (
//               <>
//                 <div className="">
//                   <span className="action-icon-buttons mt-2 mb-2">
//                     {updateAccess === '1' && !elem?.display_add_member_btn &&
//                       <Button
//                         btnStyle="light-outline"
//                         icon={<img src={icons.edit} alt="edit" />}
//                         className="me-2"
//                         onClick={() => {
//                           // setAbstractData(elem);
//                           // setRequestId(elem?.request_id);
//                           setParticipantsPopup({
//                             open: true,
//                             mode: "edit",
//                             data: elem
//                           })
//                         }}
//                         isSquare
//                       />
//                     }

//                     {/* elem.display_edit_btn && */}
//                     {viewAccess === '1' && !elem?.display_add_member_btn &&
//                       <Button
//                         btnStyle="light-outline"
//                         icon={<i className="bi bi-eye" />}
//                         className="me-2"
//                         isSquare
//                         onClick={() => {
//                           setParticipantsPopup({
//                             open: true,
//                             mode: "view",
//                             data: elem
//                           })
//                           // setAbstractData(elem);
//                           // setRequestId(elem?.request_id);
//                           // setIsView(true);
//                         }}
//                       />
//                     }

//                     {/* !elem?.display_submit_abstract &&
//                       !elem?.display_add_member_btn &&  */}
//                   </span>

//                   <div className="d-flex align-items-center justify-content-center">
//                     {elem?.display_add_member_btn && createAccess === '1' && (
//                       <span>
//                         <Button
//                           text="Add Member"
//                           btnStyle="primary-outline"
//                           icon={<i className="bi bi-plus fs-5"></i>}
//                           onClick={() => {
//                             setAddMember(!isAddMember);
//                             setRequestId(elem?.request_id);
//                           }}
//                           className="h-35 text-14-400 text-nowrap"
//                         />
//                       </span>
//                     )}

//                     {elem?.display_submit_abstract && (
//                       <span
//                       // className={
//                       //   elem.user_id && elem.join_as === 'presenter' ? '' : 'd-none'
//                       // }
//                       >
//                         {createAccess === '1' && (
//                           <Button
//                             btnStyle="primary-dark"
//                             text="Submit Abstarct"
//                             className="me-2 h-35 text-14-400 text-nowrap"
//                             onClick={() => {
//                               setAbstractData(elem);
//                               setRequestId(elem?.request_id);
//                             }}
//                           />
//                         )}
//                       </span>
//                     )}

//                     {elem?.display_payment_proof_btn &&
//                       createAccess === '1' && (
//                         <span>
//                           <Button
//                             btnStyle="primary-outline1"
//                             text="Payment Proof"
//                             className="me-2 h-35 text-14-400 text-nowrap"
//                             onClick={() => {
//                               setOpenPaymentPopup(true);
//                               setRequestId(elem?.request_id);
//                             }}
//                           />
//                         </span>
//                       )}

//                     {elem?.display_checkbox && (
//                       <span>
//                         {createAccess === '1' && (
//                           <Button
//                             btnStyle="primary-dark"
//                             text={
//                               sendingRequestId === elem?.request_id
//                                 ? 'Sending...'
//                                 : 'Send Request'
//                             }
//                             className="me-2 h-35 text-14-400 text-nowrap"
//                             onClick={() => {
//                               handleParticipantSendRequest(elem?.request_id);
//                             }}
//                             disabled={
//                               sendingRequestId === elem?.request_id ||
//                               isSendingRequest
//                             }
//                           />
//                         )}
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               </>
//             )}
//           </>
//         ),
//       },
//     ];
//     rowData.push({ data: obj });
//   });

//   return (
//     <>
//       {isAddMember && (
//         <AddMember
//           onHide={() => {
//             setAddMember(false);
//           }}
//           handelSuccess={(user_id) => {
//             setAddMember(false);
//             handleUpdateUserDetails(user_id);
//           }}
//         />
//       )}

//       {isAdd && (
//         <ParticipantsForm
//           oldData={oldData}
//           onHide={() => {
//             setIsAdd(false);
//             setOldData(null);
//           }}
//           getParticipants={() => {
//             getParticipants({ ...filterData, ...searchPayload });
//             setOldData(null);
//           }}
//         />
//       )}

//       {userID && (
//         <DeletePopup
//           onHide={() => {
//             setUserID(null);
//           }}
//           handelSuccess={() => {
//             setUserID(null);
//             getParticipants({ ...filterData, ...searchPayload });
//           }}
//           handelDelete={async () => {
//             let forData = objectToFormData({ id: userID });
//             const response = await dispatch(deleteEventParticipants(forData));
//             return response;
//           }}
//         />
//       )}
//       {/* New flow */}
//       {abstractData && (
//         <NewAbstractSubmissionFormPopup
//           eventId={eventId}
//           data={{
//             ...abstractData,
//             resource_participat_paper: '1',
//             participat_request_id: requestId,
//           }}
//           onHide={() => {
//             setAbstractData(null);
//             setIsView(false);
//           }}
//           handelSuccess={() => {
//             setRequestId('');
//             getParticipants({ ...filterData, ...searchPayload });
//           }}
//           isView={isView}
//         />
//       )}


//       {/* Old flow */}
//       {/* {abstractData && (
//         <AbstractSubmission
//           eventId={eventId}
//           data={abstractData}
//           onHide={() => {
//             setAbstractData(null);
//           }}
//         />
//       )} */}

//       {openPaymentPopup && (
//         <PaymentProofUploadPopup
//           onHide={() => setOpenPaymentPopup(false)}
//           requestId={requestId}
//           handelSuccess={() => {
//             setRequestId(null);
//             getParticipants({ ...filterData, ...searchPayload });
//           }}
//         />
//       )}

//       {isLoading ? (
//         <Card className="cpt-80 cpb-80 cmt-20">
//           <Loader size="md" />
//         </Card>
//       ) : (
//         <Card className="cps-20 cpe-20 cpb-20 mt-3">
//           {tableList.length === 0 ? (
//             <div className="row" style={{ minHeight: '600px' }}>
//               <div className="d-flex flex-column justify-content-center align-items-center w-100">
//                 <div className="text-center">
//                   <img
//                     src={icons.circleInfo}
//                     alt="No Data"
//                     className="h-60 w-60"
//                   />
//                   <div className="text-32-500-40 cmt-28 color-black-olive">
//                     Add Participants Services Not Found
//                   </div>
//                 </div>

//                 <div className="cmt-20">
//                   <Button
//                     text="+ Add Participants"
//                     btnStyle="primary-outline"
//                     className="h-35 text-14-500 text-nowrap cps-20 cpe-20"
//                     onClick={() => {
//                       setIsAdd(true);
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <>
//               <div className="d-flex justify-content-between align-items-center cpt-28 cpb-28">
//                 {selectedIds.length === 0 ? (
//                   <div className="table-title">
//                     All Participants ({filterData?.total})
//                   </div>
//                 ) : (
//                   <>
//                     <div className="d-flex gap-2 h-35">
//                       <div className="d-flex align-items-center gap-2 p-2 text-14-400-18 br-6 bg-f4fc">
//                         <CheckBox
//                           type="ACTIVE"
//                           isChecked={isCheckAll}
//                           onClick={handleSelectAllChange}
//                         />
//                         <span>Select All Users</span>
//                       </div>
//                       <div className="d-flex align-items-center gap-2 p-2 text-14-400-18 br-6 bg-f4fc">
//                         <Button
//                           text={
//                             isSendingRequest ? 'Sending...' : 'Send Request'
//                           }
//                           className="h-35 border-0"
//                           onClick={() =>
//                             handleParticipantSendRequest(selectedIds)
//                           }
//                           disabled={isSendingRequest}
//                         />
//                       </div>
//                     </div>
//                   </>
//                 )}

//                 <div className="d-flex gap-2">
//                   <div style={{ width: '150px' }}>
//                     <SeachInput
//                       placeholder="Search"
//                       value={searchText}
//                       onChange={handleSearch}
//                       className="small-text-input"
//                       iconClassName="small-search-icon"
//                     />
//                   </div>

//                   <ExportButton
//                     exportAPI={
//                       user_type === '6'
//                         ? getEventParticipantRequest
//                         : getEventParticipants
//                     }
//                     payload={objectToFormData({
//                       event_id: eventId,
//                       export_status: 1,
//                       ...filterData,
//                       ...searchPayload,
//                       ...(searchText ? { global_filter: searchText } : {}),
//                     })}
//                   />
//                   {createAccess === '1' && (
//                     <Button
//                       isSquare
//                       text="+ Add Participants"
//                       btnStyle="primary-outline"
//                       className="h-35 text-14-500 text-nowrap"
//                       onClick={() => {
//                         setIsAdd(true);
//                       }}
//                     />
//                   )}
//                 </div>
//               </div>
//               <Table
//                 isLoading={isLoading}
//                 header={header}
//                 rowData={rowData}
//                 filterData={filterData}
//                 searchPayload={searchPayload}
//                 searchInputChange={handelChangeSearch}
//                 changeOffset={handelChangePagination}
//               />
//             </>
//           )}
//         </Card>
//       )}


//       {participantsPopup?.open && (
//         <ParticipantsPopup
//           participantsPopup={participantsPopup}
//           onHide={() => {
//             setParticipantsPopup({ open: false, mode: "" })
//             setSelectedOption(null) // reset when popup closes
//           }}
//           selectedOption={selectedOption}
//           setSelectedOption={setSelectedOption}
//           getParticipants={getParticipants}
//           filterData={filterData}
//           searchPayload={searchPayload}
//         />
//       )}
//     </>
//   );
// };
// export default Participants;
